import {useEffect, useState} from "react"

/**
 * Coordinates an "exit-then-enter" transition for a changing value.
 *
 * Returns the value to render plus a boolean for whether the wrapping
 * Transition (e.g. MUI Fade) should currently be `in`. When `value` changes,
 * `inProp` flips false for `duration` ms, then the rendered value updates
 * and `inProp` flips true again.
 */
export function useDelayedSwap<T>(value: T, duration: number) {
  const [displayed, setDisplayed] = useState(value)
  const [inProp, setInProp] = useState(true)

  useEffect(() => {
    if (value === displayed) return

    setInProp(false)
    const timer = setTimeout(() => {
      setDisplayed(value)
      setInProp(true)
    }, duration)
    return () => clearTimeout(timer)
  }, [value, displayed, duration])

  return {displayed, inProp}
}
